Shopify.queryParams = {};

// overlay loading
function overlayCheckbox() {
	var overlayLoading = document.querySelector(".loading");
	overlayLoading.classList.add("mm-show");
}

function removeOverlay() {
	var overlayLoading = document.querySelector(".loading");
	overlayLoading.classList.remove("mm-show");
}

// Preserve existing query parameters
if (location.search.length) {
	let params = new URLSearchParams(location.search);

	params.forEach((value, key) => {
		Shopify.queryParams[decodeURIComponent(key)] = decodeURIComponent(value);
	});
}

function returnShopifySectionId() {
	const gridElem = document.querySelector(".mm-grid-collection");
	const gridSection = gridElem.closest(".shopify-section");
	return gridSection.id;
}
function returnShopifySectionIdShort() {
	return returnShopifySectionId().replace("shopify-section-", "");
}

// sort desktop + mobile
function setUpSortByInputs() {
    document.querySelectorAll("#SortByOk, #SortBy").forEach(function(sortEl) {
        if (sortEl.dataset.mmSortReady) return;
        sortEl.dataset.mmSortReady = '1';
        sortEl.addEventListener("change", function () {
            // Synchroniser tous les autres selects de tri avec la même valeur
            var selectedValue = sortEl.value;
            document.querySelectorAll("#SortByOk, #SortBy").forEach(function(otherEl) {
                if (otherEl !== sortEl) otherEl.value = selectedValue;
            });
            setTimeout(() => {
                fakeSubmitForm();
            }, 0);
        });
    });
}

async function refreshCollectionPageWithFilters(url_filters) {
	let currentUrl = "//" + location.host + location.pathname;
	let newPageString;

	try {
		//newPageString = await httpGet(currentUrl + "?" + url_filters);
		newPageString = await httpGet(`${currentUrl}?${url_filters}&section_id=${returnShopifySectionIdShort()}`);
	} catch (error) {
		console.error("Failed to fetch new page:", error);
		return;
	}

	// console.log('newPageString', newPageString)

	let newPageEl = document.createElement("DIV");
	newPageEl.innerHTML = newPageString;

	let newElemGrid = newPageEl.querySelector(".mm-collection-grid");
	let newElemFiltersContainer = newPageEl.querySelector(".mm-filter-group-container");
	let newElemFiltersBtn = newPageEl.querySelector(".mm-btn-filter");
	let newElemFiltersBtnPastille = newPageEl.querySelector(".mm-bg-number-filter");
	let newElemCountDesk = newPageEl.querySelector("#ProductCount");
	let activeFilters = newPageEl.querySelectorAll(".active-filters");
	const productCount = newElemCountDesk.innerText;

	// Cibler le form sidebar (pas le Hero qui est renommé collectionFacetsFormHero)
	var gridForm = document.getElementById("collectionFacetsForm");

	// Sauvegarder les groupes ouverts avant d'injecter le nouveau HTML
	var openGroups = new Set();
	if (gridForm) {
		gridForm.querySelectorAll(".mm-plp-c").forEach(function(elem) {
			if (elem.querySelector('.mm-plp-q') && elem.querySelector('.mm-plp-q').classList.contains('mm-open')) {
				openGroups.add(elem.dataset.name);
			}
		});
	}

	document.querySelector(".mm-collection-grid").innerHTML = newElemGrid.innerHTML;
	if (gridForm) {
		// Mettre à jour uniquement l'état checked/disabled des checkboxes sans recréer le DOM
		// pour éviter le flash visuel de ré-ouverture des accordéons
		var newCheckboxes = newElemFiltersContainer.querySelectorAll('input[type="checkbox"]');
		newCheckboxes.forEach(function(newCb) {
			var match = gridForm.querySelector('input[name="' + CSS.escape(newCb.name) + '"][value="' + CSS.escape(newCb.value) + '"]');
			if (match) {
				match.checked = newCb.checked;
				match.disabled = newCb.disabled;
			}
		});
	}
	document.querySelector(".mm-bg-number-filter").innerHTML = newElemFiltersBtnPastille.innerHTML;
	document.querySelector(".mm-btn-filter").innerHTML = newElemFiltersBtn.innerHTML;
	document.querySelector("#ProductCount").innerHTML = newElemCountDesk.innerHTML;
	if (document.querySelector(".mm-count-title-hco-mobile")) {
		document.querySelector(".mm-count-title-hco-mobile").innerHTML = `${productCount}<span> produits</span>`;
	}

	activeFilters.forEach(function (activeFilter) {
		var newActiveFilters = document.querySelectorAll(".active-filters");

		newActiveFilters.forEach(function (newActiveFilter) {
			newActiveFilter.innerHTML = activeFilter.innerHTML;
		});
	});

	var newSection = newPageEl.querySelector("#ProductGridContainer");

	document.querySelector("#ProductGridContainer").innerHTML = newSection.innerHTML;

	window.history.replaceState(null, document.title, currentUrl + "?" + url_filters);
	removeOverlay();
	setTimeout(() => {
		// Refaire le rename du form Hero (son innerHTML a pu être réinjecté)
		var heroFacets = document.querySelector('.mm-hero-facets-mobile');
		if (heroFacets) {
			var heroForm = heroFacets.querySelector('#collectionFacetsForm');
			if (heroForm) heroForm.id = 'collectionFacetsFormHero';
		}
		checkForChanges();
		setUpSecondaryFacetsSplides();
		setUpSortByInputs();
		if (window.innerWidth >= 1125) {
			reloadAccordeonsProductForm(openGroups);
		}
		mmResyncAllLocFilters();
		if (typeof mmSyncMobileSortSelect === 'function') mmSyncMobileSortSelect();
	}, 0);

	var sortParam = new URLSearchParams(url_filters).get('sort_by');
	if (sortParam === 'price-ascending') {
		mmSortByPrixPrincipal(true);
	} else if (sortParam === 'price-descending') {
		mmSortByPrixPrincipal(false);
	}
}

function fetchWithTimeout(url, options = {}, timeout = 7000) {
	return new Promise((resolve, reject) => {
		const controller = new AbortController();
		const signal = controller.signal;
		options.signal = signal;

		const timer = setTimeout(() => {
			controller.abort();
			reject(new Error("Request timed out"));
		}, timeout);

		fetch(url, options)
			.then((response) => {
				clearTimeout(timer);
				if (!response.ok) {
					reject(new Error("Network response was not ok"));
				}
				resolve(response);
			})
			.catch((error) => {
				clearTimeout(timer);
				reject(error);
			});
	});
}

async function httpGet(url, retries = 3, backoff = 3000) {
	for (let i = 0; i < retries; i++) {
		try {
			const response = await fetchWithTimeout(url);
			return await response.text();
		} catch (error) {
			if (i < retries - 1) {
				console.warn(`Retry ${i + 1} failed: ${error.message}. Retrying in ${backoff / 1000} seconds...`);
				await new Promise((res) => setTimeout(res, backoff));
			} else {
				console.error("Fetch error:", error);
				throw error;
			}
		}
	}
}

function mmSortByPrixPrincipal(ascending) {
	var grid = document.querySelector('#product-grid');
	if (!grid) return;

	var items = Array.from(grid.children).filter(function(child) {
		return child.querySelector('[data-prix-principal]') !== null || child.hasAttribute('data-prix-principal');
	});

	items.sort(function(a, b) {
		var cardA = a.hasAttribute('data-prix-principal') ? a : a.querySelector('[data-prix-principal]');
		var cardB = b.hasAttribute('data-prix-principal') ? b : b.querySelector('[data-prix-principal]');
		var priceA = cardA ? parseFloat(cardA.getAttribute('data-prix-principal')) || 0 : 0;
		var priceB = cardB ? parseFloat(cardB.getAttribute('data-prix-principal')) || 0 : 0;
		return ascending ? priceA - priceB : priceB - priceA;
	});

	items.forEach(function(item) { grid.appendChild(item); });
}

function checkForChanges() {
	var form = document.getElementById("collectionFacetsForm");
	var inputs = form.querySelectorAll("input");

	inputs.forEach(function (input) {
		if (input.dataset.mmListenerReady) return;
		input.dataset.mmListenerReady = '1';
		input.addEventListener("change", function () {
			overlayCheckbox();
			mmSynchronizeSecondaryFacets(input);
			setTimeout(() => {
				fakeSubmitForm();
			}, 0);
		});
	});

}

function fakeSubmitForm() {
	let form = document.getElementById("collectionFacetsForm");
	let url_filters = new URLSearchParams(new FormData(form)).toString();
	refreshCollectionPageWithFilters(url_filters);
}

window.addEventListener("DOMContentLoaded", (event) => {
	checkForChanges();
	setUpSortByInputs();
	if (window.innerWidth < 900) {
		mmCheckDrawer();
	}
	var sortByEl = document.querySelector('#SortBy');
	if (sortByEl && sortByEl.value === 'price-ascending') {
		mmSortByPrixPrincipal(true);
	} else if (sortByEl && sortByEl.value === 'price-descending') {
		mmSortByPrixPrincipal(false);
	}
});

function mmOpenFiltersMobile() {
	var wrapperMobile = document.querySelector(".mm-filters-container");
	var filterCta = document.querySelector(".filter-form");
	var wrapperMobileFilter = document.querySelector(".mm-wrapper-filter-bg");
	if (!wrapperMobile || !wrapperMobileFilter) return;
	wrapperMobile.classList.add("mm-filter-mobile-style");

	wrapperMobile.classList.add("mm-open");
	wrapperMobile.style.display = "flex";
	wrapperMobileFilter.style.display = "block";
		if (filterCta) filterCta.style.zIndex = "3";

	document.querySelector("html").classList.add("stop-scrolling");

	// Réinitialiser les accordéons à chaque ouverture du menu mobile
	setTimeout(() => {
		reloadAccordeonsProductForm();
		// Mettre à jour le compteur de filtres
		if (typeof updateCheckedCount === 'function') {
			updateCheckedCount();
		}
	}, 100);
}

function toggleFiltersMobile() {
	var wrapperMobile = document.querySelector(".mm-filters-container");
	if (!wrapperMobile) return;
	if (wrapperMobile.classList.contains("mm-open")) {
		mmCloseFiltersMobile();
		if (typeof updateCheckedCount === 'function') updateCheckedCount();
	} else {
		mmOpenFiltersMobile();
	}
}

function mmCloseFiltersMobile() {
	var wrapperMobile = document.querySelector(".mm-filters-container");
	var filterCta = document.querySelector(".filter-form");
	var wrapperMobileFilter = document.querySelector(".mm-wrapper-filter-bg");
	if (!wrapperMobile || !wrapperMobileFilter) return;
	wrapperMobile.classList.remove("mm-open");
	wrapperMobile.style.display = "none";
	wrapperMobileFilter.style.display = "none";
	if (filterCta) filterCta.style.zIndex = "2";

	document.querySelector("html").classList.remove("stop-scrolling");
}

function mmCheckDrawer() {
	var currentUrl = document.location.href.indexOf("?open_filters");
	if (currentUrl !== -1) {
		mmOpenFiltersMobile();
	}
}

